module.exports = __webpack_public_path__ + "static/img/WCE.28833b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WCE.svg
// module id = +9im
// module chunks = 1